export const TOGGLE_BANKING_ALERTS = 'TOGGLE_BANKING_ALERTS'

export const UPDATE_DELIVERY_CHANNEL = 'UPDATE_DELIVERY_CHANNEL'

export const Get_Account_Alerts = 'Get_Account_Alerts'
export const Get_AlertPreferences = 'Get_AlertPreferences'
export const RECEIVE_POSTS = 'RECEIVE_POSTS'

export const GET_BANKING_ALERTS_PENDING = 'GET_BANKING_ALERTS_PENDING'
export const GET_BANKING_ALERTS_FULFILLED = 'GET_BANKING_ALERTS_FULFILLED'
export const GET_BANKING_ALERTS_FAILED = 'GET_BANKING_ALERTS_FAILED'

export const GET_ACCOUNT_ALERTS_PENDING = 'GET_ACCOUNT_ALERTS_PENDING'
export const GET_ACCOUNT_ALERTS_FULFILLED = 'GET_ACCOUNT_ALERTS_FULFILLED'
export const GET_ACCOUNT_ALERTS_FAILED = 'GET_ACCOUNT_ALERTS_FAILED'

export const GET_ACCOUNT_ALERTS_PREFERENCES_PENDING = 'GET_ACCOUNT_PREFERENCES_ALERTS_PENDING'
export const GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED = 'GET_ACCOUNT_PREFERENCES_ALERTS_FULFILLED'
export const GET_ACCOUNT_ALERTS_PREFERENCES_FAILED = 'GET_ACCOUNT_PREFERENCES_ALERTS_FAILED'

export const GET_ACCOUNT_ALERT_TYPES_PENDING = 'GET_ACCOUNT_ALERT_TYPES_PENDING'
export const GET_ACCOUNT_ALERT_TYPES_FULFILLED = 'GET_ACCOUNT_ALERT_TYPES_FULFILLED'
export const GET_ACCOUNT_ALERT_TYPES_FAILED = 'GET_ACCOUNT_ALERT_TYPES_FAILED'

export const GET_CONTACT_PREFERENCES_FULFILLED = 'GET_CONTACT_PREFERENCES_FULFILLED'
export const UPDATE_ALERT_REGISTRATION = 'UPDATE_ALERT_REGISTRATION'
export const ADD_ALERT_REGISTRATION = 'ADD_ALERT_REGISTRATION'
export const REMOVE_ALERT_REGISTRATION = 'REMOVE_ALERT_REGISTRATION'
export const UPDATE_BANKING_ALERT_VALUES = 'UPDATE_BANKING_ALERT_VALUES'
export const ADD_BANKING_ALERT_VALUE = 'ADD_BANKING_ALERT_VALUE'
export const ADD_CURRENT_OPERATING_VALUE = 'ADD_CURRENT_OPERATING_VALUE'

export const UPDATE_ALERT_BANKING_PENDING = 'UPDATE_ALERT_BANKING_PENDING'
export const UPDATE_ALERT_BANKING_FULFILLED = 'UPDATE_ALERT_BANKING_FULFILLED'
export const UPDATE_ALERT_BANKING_FAILED = 'UPDATE_ALERT_BANKING_FAILED'

export const UPDATE_DELIVERY_METHOD = 'UPDATE_DELIVERY_METHOD'

export const DELIVERY_ADDRESS_UPDATE_ERROR = 'DELIVERY_ADDRESS_UPDATE_ERROR'
export const DELIVERY_ADDRESS_UPDATE_FULFILLED = 'DELIVERY_ADDRESS_UPDATE_FULFILLED'
export const DELIVERY_ADDRESS_UPDATE_PENDING = 'DELIVERY_ADDRESS_UPDATE_PENDING'

export const ACCOUNT_ALERT_UPDATE_ERROR = 'ACCOUNT_ALERT_UPDATE_ERROR'
export const ACCOUNT_ALERT_UPDATE_FULFILLED = 'ACCOUNT_ALERT_UPDATE_FULFILLED'
export const ACCOUNT_ALERT_UPDATE_PENDING = 'ACCOUNT_ALERT_UPDATE_PENDING'

export const BANKING_ALERTS_ERROR = 'BANKING_ALERTS_ERROR'
export const BANKING_ALERTS_FULFILLED = 'BANKING_ALERTS_FULFILLED'
export const BANKING_ALERTS_PENDING = 'BANKING_ALERTS_PENDING'

export const BANKING_ENABLE_ALERTS_ERROR = 'BANKING_ENABLE_ALERTS_ERROR'
export const BANKING_ENABLE_ALERTS_FULFILLED = 'BANKING_ENABLE_ALERTS_FULFILLED'
export const BANKING_ENABLE_ALERTS_PENDING = 'BANKING_ENABLE_ALERTS_PENDING'

export const END_OLB_PING_INCOMING = 'END_OLB_PING_INCOMING'

